/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A list of artifact metadata.
 * @export
 * @interface V2beta1ArtifactList
 */
export interface V2beta1ArtifactList {
  /**
   * A list of artifact metadata ids.
   * @type {Array<string>}
   * @memberof V2beta1ArtifactList
   */
  artifact_ids?: Array<string>;
}

/**
 * Check if a given object implements the V2beta1ArtifactList interface.
 */
export function instanceOfV2beta1ArtifactList(value: object): value is V2beta1ArtifactList {
  return true;
}

export function V2beta1ArtifactListFromJSON(json: any): V2beta1ArtifactList {
  return V2beta1ArtifactListFromJSONTyped(json, false);
}

export function V2beta1ArtifactListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ArtifactList {
  if (json == null) {
    return json;
  }
  return {
    artifact_ids: json['artifact_ids'] == null ? undefined : json['artifact_ids'],
  };
}

export function V2beta1ArtifactListToJSON(json: any): V2beta1ArtifactList {
  return V2beta1ArtifactListToJSONTyped(json, false);
}

export function V2beta1ArtifactListToJSONTyped(
  value?: V2beta1ArtifactList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    artifact_ids: value['artifact_ids'],
  };
}
